import { env } from '../../env';

export class RemoteConstants{
    static BASE_URL = env.REACT_APP_API_URL;
}